<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['username',{ rules: [{ required: true, message: '请输入学员姓名' }] }]" placeholder="请输入姓名"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['phone',{ rules: [{ required: true, message: '请输入学员手机号' }] }]" placeholder="请输入手机号"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['mailAddress']" placeholder="请输入邮箱"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="报考号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['testNo']" placeholder="请输入报考号"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="综合分数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['totalScore',{ rules: [{ required: true, message: '请输入学员综合分数' }] }]" placeholder="请输入综合分数" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="英语分数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['englishScore',{ rules: [{ required: true, message: '请输入学员英语分数' }] }]" placeholder="请输入英语分数" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="报考专业" :labelCol="labelCol" :wrapperCol="wrapperCol">
               <j-dict-select-tag
                  v-decorator="[
                    'major',
                    { rules: [{ required: true, message: '请输入报考专业' }] },
                  ]"
                  dictCode="major"
                  placeholder="请输入报考专业"
                  :triggerChange="true"
                />
              <!-- <a-input v-decorator="['major']" placeholder="请输入报考专业"  ></a-input> -->
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="报考院校" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['applySchool',{ rules: [{ required: true, message: '请输入学员报考院校' }] }]" placeholder="请输入报考院校"  ></a-input>
            </a-form-item>
          </a-col>
           <a-col :span="24">
            <a-form-item label="调剂学校" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['transferSchool']" placeholder="请输入调剂学校"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                  v-decorator="[
                    'status',
                    { rules: [{ required: false, message: '请输入状态' }] },
                  ]"
                  dictCode="transfer_status"
                  placeholder="请输入状态"
                  :triggerChange="true"
                />
              <!-- <a-input-number v-decorator="['status']" placeholder="请输入状态：1：申请，2：成功,3失败" style="width: 100%" /> -->
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="调剂说明" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['transferExplain']" placeholder="请输入调剂说明"  ></a-input> -->
              <a-textarea
                  style="height: 80px; resize: none"
                  placeholder="请输入调剂说明"
                  v-decorator="[
                    'transferExplain',
                    { rules: [{ required: false, message: '请输入调剂说明' }] },
                  ]"
                />
            </a-form-item>
          </a-col>
         
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'ElinkxApplyTransferForm',
    components: {
      JFormContainer,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/transfer/applyTransfer/add",
          edit: "/transfer/applyTransfer/edit",
          queryById: "/transfer/applyTransfer/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'username','phone','testNo','totalScore','englishScore','major','applySchool','status','transferExplain','transferSchool'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'username','phone','testNo','totalScore','englishScore','major','applySchool','status','transferExplain','transferSchool'))
      },
    }
  }
</script>